import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, ButtonBase, Typography } from '@mui/material';
import FoodPrice from '@components/offer/models/FoodPrice';
import Amount from '@components/common/molecules/Amount';
import { getSizeName } from '@components/offer/helpers/foodPriceHelper';
import FoodPriceBaseButton from './FoodPriceBaseButton';

interface FoodPriceListItemProps {
    foodPrice: FoodPrice;
    onClick: (foodPrice: FoodPrice) => void;
}

const FoodPriceListItem: React.FC<FoodPriceListItemProps> = observer(({ foodPrice, onClick }) => {
    return (
        <FoodPriceBaseButton foodPrice={foodPrice} onClick={onClick}>
            <Box>
                <Amount amount={foodPrice.price} variant='subtitle2' fontWeight={600} />
                <Typography variant='caption' color={"GrayText"}>{getSizeName(foodPrice)}</Typography>
            </Box>
        </FoodPriceBaseButton>
    )
})

export default FoodPriceListItem;